import { memo } from "react";

import { modules, useFeature } from "byzantine";

import NarmiDashboardTile from "./NarmiDashboardTile";
import { NarmiTile } from "./NarmiTile";

const NarmiTiles = ({ isDashboard }: { isDashboard?: boolean }) => {
  const tiles = modules.narmiTiles.useTiles();

  const { featureEnabled } = useFeature();

  if (!featureEnabled("tiles_web")) {
    return null;
  }

  return tiles.map((tile) =>
    isDashboard ? (
      <NarmiDashboardTile tile={tile} key={tile.client_id} />
    ) : (
      <NarmiTile tile={tile} key={tile.client_id} />
    )
  );
};

export default memo(NarmiTiles);
